import CreatePost from "./components/renderCreatePost/CreatePost";

const App = ({element}) => {

  let slug = element.getAttribute('data-slug');

    return(
        <CreatePost slug={slug} />
    )
  };

const content = document.querySelectorAll('.block-create-post');

content.forEach((element, key )=>{
  ReactDOM.render(<App element={element} />, element);
})

